export const START_TIME = 90;
